import React, { useEffect, useState } from "react";
import { H2, Section } from "../../Styles/Global.Styled";
import Carousel from "../Carousel/Carousel";
import ProductAd from "../Product/ProductAd";
import { css } from "styled-components";
import { getStoreProducts } from "../../api/product";
import Message from "./Message";

const sectionStyle = css`
  gap: 2vh;
  padding: 5vh 10vw;
`;
const sectionStyleMb = css`
  padding: 5vh 2vw;
`;

const FeatureProducts = () => {
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchProduct = async () => {
      try {
        const res = await getStoreProducts();
        setProducts(res);
      } catch (error) {}
    };
    fetchProduct();
  }, []);

  return (
    <Section
      id="featured-collection"
      $baseStyle={sectionStyle}
      $mStyle={sectionStyleMb}
    >
      <H2>Our Featured Collection</H2>
      {products.length ? (
        <Carousel items={products || []} Component={ProductAd} />
      ) : (
        <Message
          header={"Sorry!"}
          message={`We could not find any result, please try again.`}
        />
      )}
    </Section>
  );
};

export default FeatureProducts;
